import CheckMessages from "../components/CheckMessages";
import MessageOverview from "../components/MessageOverview";

export default function Messages() {
    return <>
        <h2>Messages</h2>
        <MessageOverview />
        <CheckMessages />
    </>
}